import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef } from "react";

export const AccessoriesSection = (props:any) => {


  const trackRef = useRef<HTMLDivElement>(null);

  const duplicated = [...props.accList, ...props.accList]; // Seamless infinite

  const pause = () => {
    if (trackRef.current) trackRef.current.style.animationPlayState = "paused";
  };

  const resume = () => {
    if (trackRef.current) trackRef.current.style.animationPlayState = "running";
  };



  return (
    <section className="py-20 bg-white relative overflow-hidden">

      {/* Particle Decorations */}
      <div className="absolute top-0 left-0 w-40 h-40 bg-red-300 opacity-20 blur-2xl rounded-full -z-10" />
      <div className="absolute bottom-0 right-0 w-52 h-52 bg-blue-300 opacity-20 blur-3xl rounded-full -z-10" />

      <div className="text-center mb-12">
        <p className="text-red-600 font-semibold text-sm tracking-wide uppercase">{props.title}</p>
        <h2 className="text-4xl font-bold text-gray-900 mt-2">{props.subTitle}</h2>
      </div>

    

      {/* Slider */}
      <div className="overflow-hidden max-w-7xl mx-auto px-6 sm:hidden block">
        <div
          ref={trackRef}
          onMouseEnter={pause}
          onMouseLeave={resume}
          className="flex animate-scrollInfinite group"
          style={{
            width: `${duplicated.length * 50}%`,
          }}
        >
          {duplicated.map((p, i) => (
            <div key={i} className="w-full md:w-1/4 px-4 text-center">
              <div className="bg-white rounded-xl cursor-pointer transition-all duration-300
                group-hover:shadow-xl group-hover:-translate-y-1
                hover:shadow-2xl hover:-translate-y-2">
                <div className="w-full h-52 flex items-center justify-center overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full object-fill transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="mt-4 font-semibold text-lg text-gray-900">{p.title}</h3>
                {/* <p className="mt-2 text-gray-500">
                  <span className="line-through mr-2">{p.oldPrice}</span>
                  <span className="text-red-500 font-semibold">{p.newPrice}</span>
                </p> */}
              </div>
            </div>
            
          ))}
        </div>
      </div>
      <div className="overflow-hidden max-w-7xl mx-auto px-6 sm:block hidden">
        <div
          ref={trackRef}
          onMouseEnter={pause}
          onMouseLeave={resume}
          className="flex animate-scrollInfinite group"
          style={{
            width: `${duplicated.length * 25}%`,
          }}
        >
          {duplicated.map((p, i) => (
            <div key={i} className="w-full md:w-1/4 px-4 text-center">
              <div className="bg-white rounded-xl cursor-pointer transition-all duration-300
                group-hover:shadow-xl group-hover:-translate-y-1
                hover:shadow-2xl hover:-translate-y-2">
                <div className="w-full h-52 flex items-center justify-center overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full object-fill transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="mt-4 font-semibold text-lg text-gray-900">{p.title}</h3>
                {/* <p className="mt-2 text-gray-500">
                  <span className="line-through mr-2">{p.oldPrice}</span>
                  <span className="text-red-500 font-semibold">{p.newPrice}</span>
                </p> */}
              </div>
            </div>
            
          ))}
        </div>
      </div>
    </section>
  );
}
